import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';

import {
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  FormDocument,
  FormQuery,
  FormQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
  PowertrainCardsSectionDocument,
  PowertrainCardsSectionQuery,
  PowertrainCardsSectionQueryVariables,
  PowertrainHeroDocument,
  PowertrainHeroQuery,
  PowertrainHeroQueryVariables,
  PowertrainPartnersBlogSectionDocument,
  PowertrainPartnersBlogSectionQuery,
  PowertrainPartnersBlogSectionQueryVariables,
  PowertrainProductSpecsBlocksDocument,
  PowertrainProductSpecsBlocksQuery,
  PowertrainProductSpecsBlocksQueryVariables,
  PowertrainSeoDocument,
  PowertrainSpecsDocument,
  PowertrainSpecsQuery,
  PowertrainSpecsQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { PowertrainPage } from '@/views/powertrain';

export const getStaticProps: GetStaticProps = async () => {
  const client = initializeApollo();

  // prefetch
  await client.query({ query: PowertrainHeroDocument });
  await client.query({ query: PowertrainCardsSectionDocument });
  await client.query({ query: PowertrainSpecsDocument });
  await client.query({ query: PowertrainProductSpecsBlocksDocument });
  await client.query({ query: PowertrainPartnersBlogSectionDocument });
  await client.query({ query: PowertrainSeoDocument });
  await client.query({ query: NavigationDocument });
  await client.query({ query: FooterDocument });
  await client.query({ query: FormDocument });

  const { data: seoData } = await client.query({
    query: PowertrainSeoDocument,
  });

  const { data: heroData } = await client.query<
    PowertrainHeroQuery,
    PowertrainHeroQueryVariables
  >({
    query: PowertrainHeroDocument,
  });

  const { data: cardsData } = await client.query<
    PowertrainCardsSectionQuery,
    PowertrainCardsSectionQueryVariables
  >({
    query: PowertrainCardsSectionDocument,
  });

  const { data: powertrainSpecsData } = await client.query<
    PowertrainSpecsQuery,
    PowertrainSpecsQueryVariables
  >({
    query: PowertrainSpecsDocument,
  });

  const { data: productSpecsBlocksData } = await client.query<
    PowertrainProductSpecsBlocksQuery,
    PowertrainProductSpecsBlocksQueryVariables
  >({
    query: PowertrainProductSpecsBlocksDocument,
  });

  const { data: partnersBlogSectionData } = await client.query<
    PowertrainPartnersBlogSectionQuery,
    PowertrainPartnersBlogSectionQueryVariables
  >({ query: PowertrainPartnersBlogSectionDocument });

  const { data: formData } = await client.query<FormQuery, FormQueryVariables>({
    query: FormDocument,
  });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument });

  return addApolloState(client, {
    props: {
      seoData,
      heroData,
      cardsData,
      powertrainSpecsData,
      productSpecsBlocksData,
      partnersBlogSectionData,
      formData,
      footerData,
      headerData,
    },
  });
};

const Powertrain: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  seoData,
  heroData,
  cardsData,
  powertrainSpecsData,
  productSpecsBlocksData,
  partnersBlogSectionData,
  formData,
  footerData,
  headerData,
}) => (
  <PowertrainPage
    seo={seoData?.powertrain?.data?.attributes?.seo}
    hero={heroData?.powertrain?.data?.attributes?.heroVideoSection}
    cards={cardsData?.powertrain?.data?.attributes?.cardsSection}
    powertrainSpecs={
      powertrainSpecsData?.powertrain?.data?.attributes?.technologies
    }
    productSpecsBlocks={
      productSpecsBlocksData?.powertrain?.data?.attributes?.productSpecsBlocks
    }
    partnersBlogSection={
      partnersBlogSectionData?.powertrain?.data?.attributes?.partnersBlogSection
    }
    formData={formData}
    footerData={footerData}
    headerData={headerData}
  />
);
export default Powertrain;
